import React from 'react'
import { LinkProps } from 'react-router-dom'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'

import {
  CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_DISMISS_BUTTON,
  CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_ICON,
  CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_LINK,
  CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_TEXT,
} from 'utils/testing/testIDs'

import {
  StyledBadge,
  StyledCloseButton,
  StyledIcon,
  StyledImgContainer,
  StyledLink,
  StyledText,
  StyledTextContainer,
} from './styled-components'

const displayName = 'CustomPortfolioAccountCard'

export type Props = LinkProps & {
  handleCloseClick: () => void
}

export const CustomPortfolioAccountCard = React.forwardRef<
  HTMLAnchorElement,
  Props
>(({ handleCloseClick, ...rest }, ref) => {
  const { getRemoteString } = useRemoteStrings()

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    // Since we are wrapping this button in a Link, we need to prevent the default navigation of the Link
    // and handle the close click event
    event.preventDefault()
    handleCloseClick()
  }

  return (
    <StyledLink
      aria-label="add custom stocks and etfs to your account"
      data-testid={CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_LINK}
      ref={ref}
      {...rest}
    >
      <StyledTextContainer>
        <StyledBadge data-testid={CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_ICON}>
          <StyledIcon icon={AcornsIcon.Icon.InlineLock} />
          {getRemoteString({ key: 'custom_portfolio.entry_card.tier' })}
        </StyledBadge>
        <StyledText data-testid={CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_TEXT}>
          {getRemoteString({ key: 'custom_portfolio.entry_card.title' })}
        </StyledText>
      </StyledTextContainer>
      <StyledImgContainer>
        <StyledCloseButton
          data-testid={CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_DISMISS_BUTTON}
          onClick={handleClick}
        >
          <AcornsIcon
            icon={AcornsIcon.Icon.CloseXIcon12Px}
            height="12"
            width="12"
          />
        </StyledCloseButton>
      </StyledImgContainer>
    </StyledLink>
  )
})

CustomPortfolioAccountCard.displayName = displayName
